import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 284.57 270.81"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M168.09 91V0H0v132.2h36.31v47.61l48.54-47.61h31.62v91h83.25l48.54 47.61V223.2h36.31V91H168.09Zm-86.01 34.44-39.02 38.27v-38.27H6.76V6.76h154.58V91h-44.87v34.44H82.08Zm195.72 91h-36.31v38.27l-39.02-38.27h-79.24V97.76h154.58v118.68h-.01Z",
  style: {"fill":"#181716"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }